<template>
    <q-modal
        :value="opened"
        @close="close"
        @escape-key="close"
        @hide="close"
    >
        <div class="q-pa-lg">
            <q-field
                :error="$v.form.amount.$error"
                error-label="Укажите сумму"
            >
                <q-input
                    v-model="form.amount"
                    stack-label="Сумма"
                    type="number"
                />
            </q-field>

            <q-field
                :error="$v.form.refundedAt.$error"
                error-label="Укажите дату возврата"
            >
                <q-datetime
                    v-model="form.refundedAt"
                    type="datetime"
                    clearable
                    stack-label="Дата возврата"
                />
            </q-field>

            <q-field
                :error="$v.form.serviceProvider.$error"
                error-label="Укажите поставщика услуг"
            >
                <q-select
                    v-model="form.serviceProvider"
                    :options="serviceProviders"
                    stack-label="Поставщик услуг"
                />
            </q-field>

            <q-field
                :error="$v.form.paymentMethod.$error"
                error-label="Укажите способ оплаты"
            >
                <q-select
                    v-model="form.paymentMethod"
                    :options="paymentmethods"
                    stack-label="Способ оплаты"
                />
            </q-field>

            <q-field
                :error="$v.form.reason.$error"
                error-label="Укажите комментарий"
            >
                <q-input
                    v-model="form.reason"
                    stack-label="Комментарий"
                    type="text"
                />
            </q-field>

            <div class="row justify-end q-mt-md">
                <q-btn
                    @click="save"
                    color="primary"
                    flat
                    class="q-ml-sm"
                    label="Сохранить"
                />
                <q-btn
                    @click="close"
                    color="primary"
                    flat
                    class="q-ml-sm"
                    label="Отмена"
                />
            </div>
        </div>
    </q-modal>
</template>

<script>
import { QBtn, QDatetime, QField, QInnerLoading, QInput, QModal, QSelect, QSpinner } from 'quasar'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'RefundModal',

    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        bill: {
            type: Object,
            required: true,
        },
    },

    components: {
        QInput,
        QBtn,
        QField,
        QDatetime,
        QModal,
        QInnerLoading,
        QSpinner,
        QSelect,
    },

    data () {
        return {
            form: {
                amount: 0,
                refundedAt: null,
                serviceProvider: null,
                paymentMethod: null,
                reason: null,
            },
            serviceProviders: [],
            paymentmethods: [
                {
                    label: 'WayForPay',
                    value: 'wayforpay',
                },
                {
                    label: 'Баланс',
                    value: 'balance',
                },
                {
                    label: 'Приват24',
                    value: 'privat24',
                },
                {
                    label: 'LiqPay',
                    value: 'liqpay',
                },
            ],
        }
    },

    methods: {
        close () {
            this.$emit('closed')
        },

        save () {
            this.$v.form.$touch()

            if (this.$v.form.$error) {
                return
            }

            this.$http.post(`api/v1.0/users/${this.bill.user_id}/bills/${this.bill.id}/refund`, {
                amount: this.form.amount.toString(),
                service_provider: this.form.serviceProvider,
                payment_method: this.form.paymentMethod,
                refunded_at: this.form.refundedAt,
                reason: this.form.reason,
            }).then(_ => {
                this.$q.notify({ message: 'Средства возвращены.', type: 'positive' })
            }).catch(_ => {
                this.$q.notify({ message: 'Возникала ошибка при возвращении средств.', type: 'negative' })
            })

            this.close()
        },

        fetchServiceProviders () {
            this.$http.get(`/api/v1.0/service-providers`).then(response => {
                this.$store.commit('serviceProviders/setData', response.data)
                _.forEach(response.data, (value) => {
                    this.serviceProviders.push({
                        label: value.alias,
                        value: value.id,
                    })
                })
            })
        },

        getDaysInMonth (month, year) {
            return new Date(year, month + 1, 0).getDate()
        },

        getDaysInYear (year) {
            return new Date(year, 1, 29).getDate() === 29 ? 366 : 365
        },

        calculateAmount () {
            const currentDate = new Date()
            const targetDate = new Date(this.bill.service.valid_from)
            const timeDifference = targetDate - currentDate
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))

            const currentMonth = currentDate.getMonth()
            const currentYear = currentDate.getFullYear()
            const daysInCurrentMonth = this.getDaysInMonth(currentMonth, currentYear)
            const daysInCurrentYear = this.getDaysInYear(currentYear)

            const serviceType = this.bill.service.service.id
            const amount = this.bill.amount / 100

            if (serviceType.includes('monthly')) {
                this.form.amount = (amount - (amount / daysInCurrentMonth * Math.abs(daysDifference))).toFixed(2)
                return
            }

            this.form.amount = (amount - (amount / daysInCurrentYear * Math.abs(daysDifference))).toFixed(2)
        },
    },

    mounted () {
        this.fetchServiceProviders()
        this.calculateAmount()
    },

    validations () {
        return {
            form: {
                amount: {
                    required,
                },
                serviceProvider: {
                    required,
                },
                paymentMethod: {
                    required,
                },
                refundedAt: {
                    required,
                },
                reason: {
                    required,
                },
            },
        }
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/BillsList/RefundModal.vue